import { isNil } from "lodash";
import { useEffect } from "react";
import { IntlProvider } from "react-intl";
import { Route, Switch, useRouteMatch } from "react-router-dom";
import { GainsightEvent, trackEvent } from "../../../core/common/gainsight";
import routes from "../../commons/routes";
import { useLanguage } from "../../components/LanguageProvider";
import { ResizeWrapper } from "../../components/ResizeWrapper";
import ToastProvider from "../../components/Toast/ToastProvider";
import { NotFound } from "../NotFound";
import { Payment } from "../Payment";
import { ThankYouPage } from "../ThankYouPage";

export const Root = () => {
    const isHomeMatch = useRouteMatch(routes.home());
    const isThankYouPageMatch = useRouteMatch(routes.thankYouPage());
    const { locale, messages } = useLanguage();

    useEffect(() => {
        if (
            (isNil(isHomeMatch) || !isHomeMatch.isExact) &&
            (isNil(isThankYouPageMatch) || !isThankYouPageMatch.isExact)
        ) {
            trackEvent(GainsightEvent.OpenNotFoundPage);
        }
    }, [isHomeMatch, isThankYouPageMatch]);

    return (
        <>
            <IntlProvider locale={locale} key={locale} messages={messages}>
                <ToastProvider>
                    <Switch>
                        <Route path={routes.home()} exact={true}>
                            <ResizeWrapper>
                                <Payment />
                            </ResizeWrapper>
                        </Route>
                        <Route path={routes.thankYouPage()} exact={true}>
                            <ResizeWrapper>
                                <ThankYouPage />
                            </ResizeWrapper>
                        </Route>
                        <Route path="*">
                            <NotFound />
                        </Route>
                    </Switch>
                </ToastProvider>
            </IntlProvider>
        </>
    );
};
